module.exports = __webpack_public_path__ + "media/img/avatars/teams/team-logo-5-c5e44a497ddde730051b6127d5f37eba.jpg";